// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.task-dialog {
  width: 100%;
  max-width: 672px;
  margin: auto;
  border: none;
  border-radius: 0.75rem;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  box-shadow: 0px 12px 32px rgba(11, 26, 125, 0.06);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0;
}

/* Fixes ghosting when the dialog is not open */
.task-dialog:not([open]) {
  display: none;
}

.task-dialog::backdrop {
  background-color: rgba(26, 28, 29, 0.2);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

/* --- Header Area --- */
.dialog-header {
  padding: 32px 32px 16px 32px;
}

.dialog-header-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}

.project-tag {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  color: #3b6663;
  text-transform: uppercase;
}

.close-btn {
  background: none;
  border: none;
  color: #454652;
  cursor: pointer;
  padding: 0;
  transition: color 0.2s ease;
}

.close-btn:hover {
  color: #1a1c1d;
}

.task-dialog-title {
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: -0.025em;
  color: #1a1c1d;
  line-height: 1.2;
}

/* --- Content Area --- */
.content-area {
  padding: 16px 32px 32px 32px;
  display: flex;
  flex-direction: column;
  gap: 32px;
}

/* --- Metadata Grid --- */
.meta-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.meta-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.meta-label {
  font-size: 0.625rem;
  font-weight: 700;
  color: rgba(69, 70, 82, 0.6);
  text-transform: uppercase;
  letter-spacing: -0.05em;
}

.meta-box {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 0.5rem;
}

.meta-text {
  font-size: 0.875rem;
}

.status-box {
  background-color: rgba(187, 232, 228, 0.3);
  color: #3f6a67;
}

.status-box .meta-text {
  font-weight: 600;
}

.date-box {
  background-color: #f3f3f5;
  color: #1a1c1d;
}

.date-box .meta-text {
  font-weight: 500;
}

.priority-box {
  background-color: rgba(255, 218, 214, 0.2);
  color: #ba1a1a;
}

.priority-box .meta-text {
  font-weight: 700;
}

/* --- Description Section --- */
.desc-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.desc-header {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #454652;
}

.desc-header-text {
  font-size: 0.875rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: -0.025em;
}

.task-description {
  width: 100%;
  min-height: 120px;
  background-color: #f3f3f5;
  border-radius: 0.75rem;
  padding: 16px;
  color: #454652;
  line-height: 1.625;
}
`, "",{"version":3,"sources":["webpack://./src/styles/taskDialog.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,iDAAiD;EACjD,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,UAAU;AACZ;;AAEA,+CAA+C;AAC/C;EACE,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA,wBAAwB;AACxB;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB","sourcesContent":[".task-dialog {\n  width: 100%;\n  max-width: 672px;\n  margin: auto;\n  border: none;\n  border-radius: 0.75rem;\n  background: rgba(255, 255, 255, 0.85);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  box-shadow: 0px 12px 32px rgba(11, 26, 125, 0.06);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  padding: 0;\n}\n\n/* Fixes ghosting when the dialog is not open */\n.task-dialog:not([open]) {\n  display: none;\n}\n\n.task-dialog::backdrop {\n  background-color: rgba(26, 28, 29, 0.2);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n}\n\n/* --- Header Area --- */\n.dialog-header {\n  padding: 32px 32px 16px 32px;\n}\n\n.dialog-header-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 8px;\n}\n\n.project-tag {\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  color: #3b6663;\n  text-transform: uppercase;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  color: #454652;\n  cursor: pointer;\n  padding: 0;\n  transition: color 0.2s ease;\n}\n\n.close-btn:hover {\n  color: #1a1c1d;\n}\n\n.task-dialog-title {\n  font-size: 2rem;\n  font-weight: 700;\n  letter-spacing: -0.025em;\n  color: #1a1c1d;\n  line-height: 1.2;\n}\n\n/* --- Content Area --- */\n.content-area {\n  padding: 16px 32px 32px 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n\n/* --- Metadata Grid --- */\n.meta-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n}\n\n.meta-item {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.meta-label {\n  font-size: 0.625rem;\n  font-weight: 700;\n  color: rgba(69, 70, 82, 0.6);\n  text-transform: uppercase;\n  letter-spacing: -0.05em;\n}\n\n.meta-box {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  border-radius: 0.5rem;\n}\n\n.meta-text {\n  font-size: 0.875rem;\n}\n\n.status-box {\n  background-color: rgba(187, 232, 228, 0.3);\n  color: #3f6a67;\n}\n\n.status-box .meta-text {\n  font-weight: 600;\n}\n\n.date-box {\n  background-color: #f3f3f5;\n  color: #1a1c1d;\n}\n\n.date-box .meta-text {\n  font-weight: 500;\n}\n\n.priority-box {\n  background-color: rgba(255, 218, 214, 0.2);\n  color: #ba1a1a;\n}\n\n.priority-box .meta-text {\n  font-weight: 700;\n}\n\n/* --- Description Section --- */\n.desc-section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.desc-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #454652;\n}\n\n.desc-header-text {\n  font-size: 0.875rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: -0.025em;\n}\n\n.task-description {\n  width: 100%;\n  min-height: 120px;\n  background-color: #f3f3f5;\n  border-radius: 0.75rem;\n  padding: 16px;\n  color: #454652;\n  line-height: 1.625;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
